"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonTableBody = void 0;
const React = require("react");
const filters_1 = require("../../utils/filters/filters");
const constants_1 = require("../../utils/constants");
const table_type_1 = require("./table.type");
const BronsonTableBody = (props) => {
    const renderTableBodyError = () => {
        return (React.createElement("tr", null,
            React.createElement("td", { className: 'u-text-center dh-bronson-table-body-error', colSpan: props.headers.length ? props.headers.length : constants_1.one },
                React.createElement("h4", null, "No es posible mostrar la informaci\u00F3n, intenta m\u00E1s tarde"))));
    };
    const renderTableBodyEmpty = () => {
        return (React.createElement("tr", null,
            React.createElement("td", { colSpan: props.headers.length ? props.headers.length : constants_1.one, className: 'u-text-center dh-bronson-table-body-empty' },
                React.createElement("h4", { className: 'u-mv' }, "No se encontr\u00F3 informaci\u00F3n para mostrar"))));
    };
    const renderTableBodyElement = (elem, index) => {
        if (elem.format !== undefined) {
            return (React.createElement("td", { key: index }, (0, filters_1.applyFilter)(elem.format, elem.value, elem.args ? elem.args : {})));
        }
        else {
            return React.createElement("td", { key: index }, elem.value);
        }
    };
    const renderTableBody = () => {
        if (props.tableState === table_type_1.BronsonTableState.done && !props.data.length) {
            return renderTableBodyEmpty();
        }
        else if (props.tableState === table_type_1.BronsonTableState.error) {
            return renderTableBodyError();
        }
        return props.data.map((row, index) => {
            return (React.createElement("tr", { key: index }, row.map((elem, i) => {
                return renderTableBodyElement(elem, i);
            })));
        });
    };
    return React.createElement("tbody", null, renderTableBody());
};
exports.BronsonTableBody = BronsonTableBody;
